var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.3,6.7l-11-6.5C2.4-0.3,1,0.2,1,1.5v13c0,1.2,1.3,1.9,2.3,1.3l11-6.5C15.2,8.7,15.2,7.3,14.3,6.7L14.3,6.7z","fill":"#ffffff"}));
}

Play.defaultProps = {"version":"1.1","width":"16","height":"16","fill":"none","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
